import { axiosClient, TPagination } from "@/configurations/axios"

import { queryClient } from "@/configurations/react-query"
import { queryOptions } from "@tanstack/react-query"
import { FAQ_ENDPOINTS, FAQ_KEYS } from "../configs/endpoints"
import { TFAQCategory } from "../types"

const DEFAULT_PAGE_NUMBER = 1
const DEFAULT_PAGE_LIMIT = 10000

const getExposedFAQCategoryList = async () => {
  const response = await axiosClient.get<TPagination<TFAQCategory>>(
    FAQ_ENDPOINTS.getFAQCategoryList,
    {
      params: {
        pageNumber: DEFAULT_PAGE_NUMBER,
        pageLimit: DEFAULT_PAGE_LIMIT
      }
    }
  )
  return response.data.data.filter(item => item.isExpose)
}

export const getExposedFAQCategoryListQueryOptions = () => {
  return queryOptions({
    queryKey: FAQ_KEYS.faqCategoryList(),
    queryFn: getExposedFAQCategoryList
  })
}

export const getExposedFAQCategoryListLoader = () => {
  return queryClient.ensureQueryData(getExposedFAQCategoryListQueryOptions())
}
